import * as React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Chip } from "@mui/material";
import Button from "@mui/material/Button";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { getUserName } from "../Authentication/authSlice";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import HistoryIcon from "@mui/icons-material/History";
import { useDispatch } from "react-redux";
import { setlogo } from "./Nav/navSlice";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { PENDING_REFRESH, useGetPendingJobCardsQuery, useGetQEJobCardHistoryQuery } from "../api/apiSlice";
import { BG, CARD_BG, BORDER, AMBER } from "../../Global/colors";

export default function QEDashboard() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user_name = useSelector(getUserName);

  dispatch(setlogo(true));

  return (
    <>
      <Helmet>
        <style>{`body { background: ${BG}; }`}</style>
      </Helmet>

      <Box sx={{ px: "20px", pt: "88px", pb: "40px", maxWidth: "480px", mx: "auto" }}>
        {/* Page header */}
        <Box sx={{ mb: "32px" }}>
          <Typography sx={{ fontSize: "1.9rem", fontWeight: 800, color: "#fff", letterSpacing: "-0.03em", lineHeight: 1.15 }}>
            Tjommie QE App
          </Typography>
          <Typography sx={{ fontSize: "0.85rem", color: "rgba(255,255,255,0.4)", mt: "6px" }}>
            QE · {user_name}
          </Typography>
        </Box>

        {/* Nav cards */}
        <NavCards navigate={navigate} />

        {/* New Install */}
        <Box sx={{ mt: "28px", display: "flex", justifyContent: "center" }}>
          <Button
            endIcon={<ChevronRightIcon />}
            onClick={() => navigate("/installer/")}
            sx={{
              backgroundColor: CARD_BG,
              color: "#fff",
              fontWeight: 600,
              fontSize: "0.9rem",
              textTransform: "none",
              borderRadius: "10px",
              px: "28px",
              py: "10px",
              border: `1px solid ${BORDER}`,
              boxShadow: "none",
              "&:hover": { backgroundColor: "#1e2730", boxShadow: "none" },
            }}
          >
            New Install
          </Button>
        </Box>
      </Box>
    </>
  );
}

function NavCards({ navigate }) {
  const { data: pendingData, isSuccess: pendingOk } = useGetPendingJobCardsQuery(undefined, PENDING_REFRESH);
  const { data: historyData, isSuccess: historyOk } = useGetQEJobCardHistoryQuery();

  if (!pendingOk || !historyOk) return null;

  const pendingCount = pendingData.count ?? pendingData.job_cards.length;
  const historyCount = historyData.count ?? historyData.job_cards.length;

  const cards = [
    {
      icon: <NotificationsActiveIcon sx={{ fontSize: "1.3rem", color: AMBER }} />,
      label: "Pending Installs",
      count: pendingCount,
      chipAmber: true,
      onClick: () => navigate("/QE/pending-installs/"),
    },
    {
      icon: <HistoryIcon sx={{ fontSize: "1.3rem", color: AMBER }} />,
      label: "History",
      count: historyCount,
      chipAmber: false,
      onClick: () => navigate("/QE/history/"),
    },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      {cards.map((card) => (
        <Box
          key={card.label}
          onClick={card.onClick}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: CARD_BG,
            border: `1px solid ${BORDER}`,
            borderRadius: "12px",
            p: "18px 20px",
            cursor: "pointer",
            transition: "background 0.15s",
            "&:hover": { backgroundColor: "#1e2730" },
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "14px" }}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: "10px",
                backgroundColor: "rgba(253,185,64,0.12)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              {card.icon}
            </Box>
            <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: "0.95rem" }}>
              {card.label}
            </Typography>
          </Box>
          <Chip
            label={card.count}
            size="small"
            sx={{
              backgroundColor: card.chipAmber ? AMBER : "rgba(255,255,255,0.1)",
              color: card.chipAmber ? "#0d1117" : "rgba(255,255,255,0.7)",
              fontWeight: 700,
              fontSize: "0.8rem",
              height: "26px",
            }}
          />
        </Box>
      ))}
    </Box>
  );
}
